import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_viewlog } from "../shared/data.service";

import { wsVPPAdminVisitorLogPrintDataParm } from "../shared/wsVPPAdminVisitorLogPrintDataParm";
import { wsVPPAdminVisitorLogPrintDataInfo } from "../shared/wsVPPAdminVisitorLogPrintDataInfo";
import { wsVisitorLogStatusInfo } from "../shared/wsVPPAdminVisitorLogPrintDataInfo";
import { wsVisitorLogDateRangeInfo } from "../shared/wsVPPAdminVisitorLogPrintDataInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./printvisitorslog.component.html",
	styleUrls: ["./printvisitorslog.component.css"],
	providers: [ConfirmationService],
})
export class PrintVisitorsLogComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_viewlog,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public UserID: number;
	public FacilityID: number;
	public DateRangeID: number;
	public StartDate: Date = new Date();
	public EndDate: Date = new Date();

	public VisitorLogPrintData: wsVPPAdminVisitorLogPrintDataInfo;

	//	LogStatus Selector
	public lstStatusItems: wsVisitorLogStatusInfo[] = [];
	public SelectedStatus: wsVisitorLogStatusInfo;

	public lstDateRangeItems: wsVisitorLogDateRangeInfo[] = [];

	//	SortBy Selector
	public lstSortBy: any = [];
	public SelectedSortBy: any;
	public isASC: boolean;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.UserID = this.dialogConfig.data.UserID;
		this.FacilityID = this.dialogConfig.data.FacilityID;
		this.DateRangeID = this.dialogConfig.data.DateRangeID;
		this.StartDate = this.dialogConfig.data.StartDate;
		this.EndDate = this.dialogConfig.data.EndDate;

		//
		//	Set lstSortBy Selector
		//
		this.lstSortBy = [
			{
				SortByID: 1,
				SortByCD: "LogDT",
				SortByDesc: "Log Date (Default)",
			},
			{ SortByID: 2, SortByCD: "LastName", SortByDesc: "Last Name" },
			{ SortByID: 3, SortByCD: "FirstName", SortByDesc: "First Name" },
			{
				SortByID: 4,
				SortByCD: "VisitorLogStatus",
				SortByDesc: "Log Status",
			},
			{
				SortByID: 5,
				SortByCD: "EntryFacilityLocation",
				SortByDesc: "Entry Location",
			},
			{
				SortByID: 6,
				SortByCD: "DestinationFacilityLocation",
				SortByDesc: "Destination Location",
			},
			{ SortByID: 7, SortByCD: "FacilityName", SortByDesc: "Facility" },
		];

		this.SelectedSortBy = this.lstSortBy[0];

		//
		//	Get Load Data
		//
		let parms: wsVPPAdminVisitorLogPrintDataParm = {
			StartDateCustom: this.StartDate,
			EndDateCustom: this.EndDate,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorLogPrintDataGet(parms).subscribe((data) => this.VPPAdminVisitorLogPrintDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorLogPrintDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorLogPrintDataGet_Complete(data: any) {
		this.VisitorLogPrintData = data;

		this.lstStatusItems = this.VisitorLogPrintData.StatusItems;
		this.lstDateRangeItems = this.VisitorLogPrintData.DateRangeItems;

		//
		//	Default Select Status
		//
		this.lstStatusItems.unshift({
			VisitorLogStatusID: 0,
			VisitorLogStatusDesc: "- ALL -",
		});

		this.SelectedStatus = this.lstStatusItems[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSortByChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSortByChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		var StartDateWork: Date;
		var EndDateWork: Date;

		if (this.SelectedStatus.VisitorLogStatusID == 5) {
			// Custom
			StartDateWork = this.StartDate;
			EndDateWork = this.EndDate;
		} else {
			this.lstDateRangeItems.forEach((item) => {
				if (this.DateRangeID == item.DateRangeID) {
					StartDateWork = item.StartDate;
					EndDateWork = item.EndDate;
				}
			});
		}

		this.isASC = true; // Only Do Ascending For Now

		var result = this.dataService.Print_RPTVisitorLog(
			this.SelectedStatus.VisitorLogStatusID,
			StartDateWork,
			EndDateWork,
			this.FacilityID,
			this.SelectedSortBy.SortByCD,
			this.isASC,
			this.UserID
		);

		//
		//	Generate PDF
		//
		this.isBusy = true;
		result.subscribe(
			(response: any) => {
				this.isBusy = false;

				if (response == "No Data available") {
					this.ErrorMessage = response;
				} else {
					window.open(response);

					//
					// 0 = CANCEL; 1 = SAVE
					//
					this.ref.close(1);
				}
			},
			(error) => {
				this.isBusy = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
